<script setup>
import {onMounted, reactive, ref, watch} from "vue";
import {useUser} from "../../store/user"
import {useSystem} from "../../store/system"
const userStore = useUser()
const systemStore = useSystem()
// 获取面板统计数据
userStore.getUserStatisticsApi()
// 获取充值和提现记录
userStore.getRecentDepositLogApi()
userStore.getRecentWithdrawLogApi()

const iconBgColors = ['tw-bg-blue-500', 'tw-bg-red-500', 'tw-bg-green-500', 'tw-bg-yellow-500', 'tw-bg-purple-500', 'tw-bg-pink-500',
  'tw-bg-indigo-500', 'tw-bg-teal-500', 'tw-bg-orange-500', 'tw-bg-amber-500', 'tw-bg-lime-500', 'tw-bg-emerald-500', 'tw-bg-cyan-500',
    'tw-bg-sky-500', 'tw-bg-violet-500', 'tw-bg-fuchsia-500', 'tw-bg-rose-500'
]

const getRandomColor = () => {
  let index = Math.floor(Math.random() * iconBgColors.length)
  return iconBgColors[index]
}

</script>

<template>

  <el-row>
    <el-col :span="24">

      <div class="tw-text-white">
        <div class="tw-py-3">Affiliate Link</div>
        <div class="tw-flex tw-justify-between tw-items-center link-bg tw-p-6 tw-rounded-lg">
          <div>{{userStore.getInviteLink}}</div>
<!--          使用watch只监听一次全局挂载 在header中实现的 copyBtn 该功能-->
          <el-button class="copyBtn">Copy</el-button>
        </div>
      </div>
    </el-col>
  </el-row>

  <el-row :gutter="20" class="tw-mt-6">
    <el-col :span="24" :md="6">

      <div class="card-bg tw-p-4 tw-rounded-lg tw-group tw-mt-4 lg:!tw-mt-0">
        <div class="tw-flex tw-justify-start tw-items-center">
          <div :class="getRandomColor()" class="tw-w-[45px] tw-h-[45px] tw-bg-opacity-50 group-hover:tw-bg-opacity-100 tw-flex tw-justify-center tw-items-center tw-rounded-md tw-shrink-0">
            <font-awesome-icon class="tw-text-[25px]" :icon="['fas', 'wallet']" />
          </div>
          <div class="tw-ml-3 tw-text-[16px] tw-font-bold">Available Balance</div>
        </div>
        <div class="tw-mt-3 tw-text-[20px]"><span class="tw-mr-1">$</span>{{userStore.getStaticsData.available_balance}}</div>
      </div>

    </el-col>
    <el-col :span="24" :md="6">

      <div class="card-bg tw-p-4 tw-rounded-lg tw-group tw-mt-4 lg:!tw-mt-0">
        <div class="tw-flex tw-justify-start tw-items-center">
          <div :class="getRandomColor()" class="tw-w-[45px] tw-h-[45px] tw-bg-opacity-50 group-hover:tw-bg-opacity-100 tw-flex tw-justify-center tw-items-center tw-rounded-md tw-shrink-0">
            <font-awesome-icon class="tw-text-[25px]" :icon="['fas', 'money-bill-trend-up']" />
          </div>
          <div class="tw-ml-3 tw-text-[16px] tw-font-bold">Trial Funds</div>
        </div>
        <div class="tw-mt-3 tw-text-[20px]"><span class="tw-mr-1">$</span>{{userStore.getStaticsData.trial_funds}}</div>
      </div>

    </el-col>
    <el-col :span="24" :md="6">

      <div class="card-bg tw-p-4 tw-rounded-lg tw-group tw-mt-4 lg:!tw-mt-0">
        <div class="tw-flex tw-justify-start tw-items-center">
          <div :class="getRandomColor()" class="tw-w-[45px] tw-h-[45px] tw-bg-opacity-50 group-hover:tw-bg-opacity-100 tw-flex tw-justify-center tw-items-center tw-rounded-md tw-shrink-0">
            <font-awesome-icon class="tw-text-[25px]" :icon="['fas', 'money-check-dollar']" />
          </div>
          <div class="tw-ml-3 tw-text-[16px] tw-font-bold">Total Deposit</div>
        </div>
        <div class="tw-mt-3 tw-text-[20px]"><span class="tw-mr-1">$</span>{{userStore.getStaticsData.total_deposit}}</div>
      </div>

    </el-col>
    <el-col :span="24" :md="6">

      <div class="card-bg tw-p-4 tw-rounded-lg tw-group tw-mt-4 lg:!tw-mt-0">
        <div class="tw-flex tw-justify-start tw-items-center">
          <div :class="getRandomColor()" class="tw-w-[45px] tw-h-[45px] tw-bg-opacity-50 group-hover:tw-bg-opacity-100 tw-flex tw-justify-center tw-items-center tw-rounded-md tw-shrink-0">
            <font-awesome-icon class="tw-text-[25px]" :icon="['fas', 'money-bill-transfer']" />
          </div>
          <div class="tw-ml-3 tw-text-[16px] tw-font-bold">Total Withdraw</div>
        </div>
        <div class="tw-mt-3 tw-text-[20px]"><span class="tw-mr-1">$</span>{{userStore.getStaticsData.total_withdraw}}</div>
      </div>

    </el-col>
    <el-col :span="24" :md="6">

      <div class="card-bg tw-p-4 tw-rounded-lg tw-group tw-mt-4">
        <div class="tw-flex tw-justify-start tw-items-center">
          <div :class="getRandomColor()" class="tw-w-[45px] tw-h-[45px] tw-bg-opacity-50 group-hover:tw-bg-opacity-100 tw-flex tw-justify-center tw-items-center tw-rounded-md tw-shrink-0">
            <font-awesome-icon class="tw-text-[25px]" :icon="['fas', 'hand-holding-dollar']" />
          </div>
          <div class="tw-ml-3 tw-text-[16px] tw-font-bold">Active Plans</div>
        </div>
        <div class="tw-mt-3 tw-text-[20px]"><span class="tw-mr-1">$</span>{{userStore.getStaticsData.active_plans}}</div>
      </div>

    </el-col>
    <el-col :span="24" :md="6">

      <div class="card-bg tw-p-4 tw-rounded-lg tw-group tw-mt-4">
        <div class="tw-flex tw-justify-start tw-items-center">
          <div :class="getRandomColor()" class="tw-w-[45px] tw-h-[45px] tw-bg-opacity-50 group-hover:tw-bg-opacity-100 tw-flex tw-justify-center tw-items-center tw-rounded-md tw-shrink-0">
            <font-awesome-icon class="tw-text-[25px]" :icon="['fas', 'sack-dollar']" />
          </div>
          <div class="tw-ml-3 tw-text-[16px] tw-font-bold">Today Profits</div>
        </div>
        <div class="tw-mt-3 tw-text-[20px]"><span class="tw-mr-1">$</span>{{userStore.getStaticsData.today_profits}}</div>
      </div>

    </el-col>
    <el-col :span="24" :md="6">

      <div class="card-bg tw-p-4 tw-rounded-lg tw-group tw-mt-4">
        <div class="tw-flex tw-justify-start tw-items-center">
          <div :class="getRandomColor()" class="tw-w-[45px] tw-h-[45px] tw-bg-opacity-50 group-hover:tw-bg-opacity-100 tw-flex tw-justify-center tw-items-center tw-rounded-md tw-shrink-0">
            <font-awesome-icon class="tw-text-[25px]" :icon="['fas', 'coins']" />
          </div>
          <div class="tw-ml-3 tw-text-[16px] tw-font-bold">Today Rewards</div>
        </div>
        <div class="tw-mt-3 tw-text-[20px]"><span class="tw-mr-1">$</span>{{userStore.getStaticsData.today_rewards}}</div>
      </div>

    </el-col>
    <el-col :span="24" :md="6">

      <div class="card-bg tw-p-4 tw-rounded-lg tw-group tw-mt-4">
        <div class="tw-flex tw-justify-start tw-items-center">
          <div :class="getRandomColor()" class="tw-w-[45px] tw-h-[45px] tw-bg-opacity-50 group-hover:tw-bg-opacity-100 tw-flex tw-justify-center tw-items-center tw-rounded-md tw-shrink-0">
            <font-awesome-icon class="tw-text-[25px]" :icon="['fas', 'user-group']" />
          </div>
          <div class="tw-ml-3 tw-text-[16px] tw-font-bold">Today Referrals</div>
        </div>
        <div class="tw-mt-3 tw-text-[20px]"><span class="tw-mr-1">$</span>{{userStore.getStaticsData.today_referrals}}</div>
      </div>

    </el-col>
  </el-row>

  <el-row :gutter="systemStore.getIsMobile? 0: 20">
    <el-col :span="24" class="tw-mt-10">
      <div class="card-bg tw-rounded-lg">
        <div class="tw-flex tw-justify-between tw-items-center tw-bottom-line tw-px-4 tw-py-3">
          <div class="tw-text-[20px] tw-font-bold">Recent deposit</div>
          <el-button>View all</el-button>
        </div>

        <el-table
            :data="userStore.getDepositLog"
            class="tw-w-full"
            :height="300"
        >

          <el-table-column prop="payment_id" label="Payment">
            <template #default="{row, column, $index}">
              <div class="tw-h-full tw-flex tw-justify-start tw-items-center">
                <el-avatar class="tw-flex-none" v-if="row.image" :size="30" :src="row.image" />
                <div class="tw-ml-2">{{row.name}}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="submit_amount" label="Recharge amount">
            <template #default="{row, column, $index}">
              <div>$ {{parseFloat(row.submit_amount).toFixed(2)}}</div>
            </template>
          </el-table-column>

          <el-table-column prop="createtime" label="Date">
            <template #default="{row, column, $index}">
              <div>{{systemStore.formatDate(row.createtime)}}</div>
            </template>
          </el-table-column>
          <template #empty>
            <el-empty :image-size="120"></el-empty>
          </template>
        </el-table>

      </div>
    </el-col>
    <el-col :span="24" class="tw-mt-10">
      <div class="card-bg tw-rounded-lg">
        <div class="tw-flex tw-justify-between tw-items-center tw-bottom-line tw-px-4 tw-py-3">
          <div class="tw-text-[20px] tw-font-bold">Recent withdraw</div>
          <el-button>View all</el-button>
        </div>
        <el-table
            :data="userStore.getWithdrawLog"
            class="tw-w-full"
            :height="300"
        >

          <el-table-column prop="payment_id" label="Payment">
            <template #default="{row, column, $index}">
              <div class="tw-h-full tw-flex tw-justify-start tw-items-center">
                <el-avatar class="tw-flex-none" v-if="row.image" :size="30" :src="row.image" />
                <div class="ml-2">{{row.name}}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="submit_amount" label="Recharge amount">
            <template #default="{row, column, $index}">
              <div>$ {{parseFloat(row.submit_amount).toFixed(2)}}</div>
            </template>
          </el-table-column>

          <el-table-column prop="createtime" label="Date">
            <template #default="{row, column, $index}">
              <div>{{systemStore.formatDate(row.createtime)}}</div>
            </template>
          </el-table-column>
          <template #empty>
            <el-empty :image-size="120"></el-empty>
          </template>
        </el-table>
      </div>
    </el-col>
  </el-row>
</template>

<style lang="scss">
.link-bg{
  background: $p-bg-linear-color;
  border: 2px solid $p-border-color;
  color: $p-text-color;

  &:hover{
    background: $p-bg-linear-active-color;
  }
}
</style>
